<!-- TABLA DETALLES-->
<table datatable [dtOptions]="dtOptions" class="table table-striped hover bordered">
    <thead>
        <tr>
            <th scope="col">Tipo de evento</th>
            <th scope="col">Fecha y hora</th>
            <th scope="col">Duración</th>
            <th scope="col">Descripción</th>
            <th scope="col" class="hide">lat</th>
            <th scope="col" class="hide">lon</th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor='let event of events'>
            <td>
                {{event.eventType}}
            </td>
            <td>
                {{event.timeStamp}}
            </td>
            <td>
                {{event.duration}} segundos
            </td>
            <td>
                {{event.description}}
            </td>
            <td class="hide">
                {{event.lat}}
            </td>
            <td class="hide">
                {{event.lon}}
            </td>
        </tr>
    </tbody>
</table>
